module.exports = __webpack_public_path__ + "static/media/PanelImage.86109ed2.png";